// ----------------------------------------------------------------------------
// Animations
// ----------------------------------------------------------------------------
//
// Stores all iamota animation variation for reference into individual components.
// Re-runs visibility check on shopify:section:load so animations work in the theme editor.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Load Styles
// -------------------------------------

import './animations.scss';

// -------------------------------------
// Helpers
// -------------------------------------

/**
 * Checks if an element is visible within the viewport.
 * @param {HTMLElement} element - The element to check visibility for.
 * @param {boolean} partial - Whether partial visibility counts as visible.
 * @returns {boolean} - True if the element is visible, false otherwise.
 */
function isElementVisible(element, partial) {
  var viewTop = window.pageYOffset || document.documentElement.scrollTop;
  var viewBottom = viewTop + window.innerHeight;
  var rect = element.getBoundingClientRect();
  var elemTop = rect.top + viewTop;
  var elemBottom = elemTop + rect.height;
  var compareTop = partial ? elemBottom : elemTop;
  var compareBottom = partial ? elemTop : elemBottom;
  return compareBottom <= viewBottom && compareTop >= viewTop;
}

/**
 * Updates visibility and animation classes for .animate-in elements within a scope.
 * @param {Document|Element} scope - Root to query (.animate-in must be inside this).
 */
function runVisibilityCheck(scope) {
  var root = scope instanceof Document ? scope.documentElement : scope;
  var animatedElements = root.querySelectorAll('.animate-in');
  animatedElements.forEach(el => {
    if (isElementVisible(el, true)) {
      if (!el.classList.contains('already-visible')) {
        el.classList.add('already-visible');
      }
      if (!el.classList.contains('is-animated')) {
        el.classList.add('is-animated');
      }
    } else if (el.classList.contains('already-visible')) {
      el.classList.remove('already-visible');
    }
  });
}

/**
 * Handles the scroll event: add is-animated to .animate-in elements when they enter view.
 */
function handleScroll() {
  document.querySelectorAll('.animate-in').forEach(el => {
    if (isElementVisible(el, true) && !el.classList.contains('is-animated')) {
      el.classList.add('is-animated');
    }
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
  runVisibilityCheck(document);
  window.addEventListener('scroll', handleScroll, {
    capture: true,
    passive: true
  });
});

// Re-run visibility check when a section is added or re-rendered in the theme editor
document.addEventListener('shopify:section:load', event => {
  runVisibilityCheck(event.target);
});